import React, { useState } from "react";

import { Box, Button, IconButton, Typography } from "@mui/material";
import { RiFullscreenExitLine, RiFullscreenLine } from "@remixicon/react";
import ReviewGeneralBrandMetadata from "./ReviewBrandGeneralMetadata";
import ReviewBrandCountries from "./ReviewBrandCountries";
import ReviewBrandGeos from "./ReviewBrandGeos";
import ReviewBrandParents from "./ReviewBrandParents";
import ReviewBrandChildren from "./ReviewBrandChildren";

interface BrandMetadataReviewProps {
  brand_id: string;
  brand_name: string;
  chain_id: string;
}
const BrandMetadataReview: React.FC<BrandMetadataReviewProps> = ({
  brand_id,
  brand_name,
  chain_id,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
  };

  return (
    <Box
      sx={
        isFullscreen
          ? {
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "#fff",
              overflow: "auto",
              p: 5,
              pt: 0,
            }
          : {
              position: "relative",
              width: "auto",
              height: "auto",
              minHeight: "500px",
              overflow: "hidden",
              border: "1px solid #ccc",
              borderRadius: "4px",
              p: 5,
              mt: 2,
              backgroundColor: "#fff",
            }
      }
    >
      {/* Top Bar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          ...(isFullscreen && {
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            width: "100%",
            zIndex: 1000,
            p: 2,
          }),
        }}
      >
        <Typography variant="h5">
          {isFullscreen ? `Brand: ${brand_name}` : ""}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Open Kuebiko Button */}
          <Button
            variant="outlined"
            color="primary"
            startIcon={
              <img
                src="/images/dataplor_logo.svg"
                alt="dataplor logo"
                style={{ width: 20, height: 20 }}
              />
            }
            onClick={() =>
              window.open(
                `https://kuebiko.dataplor.com/brands/${brand_id}/edit`,
                "_blank"
              )
            }
          >
            Open Kuebiko
          </Button>
          {/* Fullscreen Toggle Button */}
          <IconButton onClick={toggleFullscreen} sx={{ zIndex: 500 }}>
            {isFullscreen ? <RiFullscreenExitLine /> : <RiFullscreenLine />}
          </IconButton>
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ mb: 2 }}>
        {/* Part 1*/}
        <Box>
          <Typography variant="h6" gutterBottom>
            General Brands Metadata Review
          </Typography>
          {/* Review Notes and Wikipedia */}
          <ReviewGeneralBrandMetadata brand_id={brand_id} />
          {/* Review Brand Countries */}
          <ReviewBrandCountries brand_id={brand_id} />
          {/* Review Brand Geos */}
          <ReviewBrandGeos chain_id={chain_id} />
          {/* Review Brand Parents */}
          <ReviewBrandParents brand_id={brand_id} />
          {/* Review Brand Children */}
          <ReviewBrandChildren brand_id={brand_id} />
        </Box>
      </Box>
    </Box>
  );
};

export default BrandMetadataReview;
